import React from "react";
import { useSelector } from "react-redux";
import useLanguageSelector from "./useLanguageSelector";

const HeadingComp = (props) => {
  const { english, hindi } = props;
  const selectedLanguage = useSelector(
    (state) => state.laguagefoetheemployees.COuntsForLanguage
  );

  return (
    <div className="row">
      <div className="col-12 leaveHeading text-left">
        <h3>{useLanguageSelector(english, hindi)}</h3>
      </div>
    </div>
  );
};

export default HeadingComp;
